<template>
    <dx-context-menu
        ref='menuRef'
        :target='target'
        :data-source='menuItems'
        :hide-on-outside-click='true'
        :select-by-click="true"
        :selection-mode="'single'"
        @showing='setMenuItems'
        @hiding='hideOpenMenu'
        @item-click='onMenuItemClick'
    >
        <template #item="{ data }">
            <img v-if='data?.icon' :src="`/infoenergo/assets/tep/tep-tree-menu/menu_item_${data?.menu_id}.svg`"
                 alt='Иконка' class='tep-tree-item-img' />
            <span>{{ data?.name }}</span>
        </template>
    </dx-context-menu>
</template>

<script>
export default {
    name: 'tep-tree-context-menu',
};
</script>

<script setup>
import { DxContextMenu } from 'devextreme-vue';
import { dxUiNotify } from '@/utils/dx-helper';
import { ref } from 'vue';
import store from './store/tep-tree-store';
import { confirm } from 'devextreme/ui/dialog';

const props = defineProps({
    target: {
        type: String,
        default: () => ''
    },
    treeItemData: {
        type: Object,
        default: () => {}
    },
    moveEnabled: {
        type: Boolean,
        default: () => false
    },
    copiedItem: {
        type: Object,
        default: () => null
    },
});

const emit = defineEmits(['expandItem', 'copyKod', 'moveItem', 'createItem', 'deleteItem', 'getOpenEl']);

const menuItems = ref([]);
const menuRef = ref();

const menuItemMove = {menu_id: -1, name: 'Переместить элемент с кодом ### сюда как дочерний', icon: false};
const addMoveMenuItem = () => {
    const ind = menuItems.value.findIndex(item => item.menu_id === -1);
    const currentMenu = [...menuItems.value];
    if (props.moveEnabled && ind === -1 && props.copiedItem) {
        const itemsKodArr = currentMenu.find(el => el.menu_id === 3)?.items?.map(el => el.kod);
        if (itemsKodArr && itemsKodArr.includes(props.copiedItem.kod_vid)) {
            const newMenuItem = { ...menuItemMove };
            newMenuItem.name = newMenuItem.name.replace("###", props.copiedItem.kod);
            currentMenu.splice(1, 0, newMenuItem);
            menuItems.value = currentMenu;
        }
    } else if (!props.moveEnabled && ind !== -1) {
        currentMenu.splice(ind, 1);
        menuItems.value = currentMenu;
    }
};

const setMenuItems = () => {
    if (menuItems.value.length === 0) {
        menuItems.value = store.getMenu(props.treeItemData.kod_vid, props.treeItemData.kod_vid_r);
    }
    emit('getOpenEl', menuRef.value?.instance);
    addMoveMenuItem();
};

const hideOpenMenu = () => {
    emit('getOpenEl',null);
}

// region onMenuItemClick
const copyTextToClipboard = (text) => {
    console.log('$TEP_INFO$ for copy:', text);
    if (!document.location.protocol.includes('https') && !document.location.host.includes('localhost')) {
        dxUiNotify('Невозможно использовать копирование по кнопке. Используйте другие методы', 'error')
    } else {
        navigator.clipboard.writeText(text).then(() => {
            dxUiNotify('Код скопирован', 'success')
        }, (err) => {
            console.error('$TEP_INFO$ Ошибка копирования:', err);
            dxUiNotify('Произошла ошибка копирования. Попробуйте еще раз', 'error')
        });
    }
};

const onDeletePopupShow = async (kod, name) => {
    return await confirm(
        `Вы уверены, что хотите удалить элемент ${name} (код: ${kod})?`,
        'Подтвердите удаление'
    );
};

const findMenuItemId = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            let selectedItemId = null;
            for (const item of menuItems.value) {
                if (item.items) {
                    const selectedItem = item.items.find(el => el.selected === true);
                    if (selectedItem) {
                        selectedItemId = item.menu_id;
                        break;
                    }
                }
            }
            resolve(selectedItemId);
        }, 0);
    })
};

const onMenuItemClick = async (event) => {
    const menuId = event.itemData.menu_id || await findMenuItemId();
    switch (menuId) {
        case -1:
            //                кого,                 куда
            emit('moveItem', props.copiedItem.kod, props.treeItemData.kod);
            break;
        case 1:
            copyTextToClipboard(props.treeItemData.kod);
            emit('copyKod', props.treeItemData);
            break;
        // пункты 2 и 3 посылают код будущего родителя и код вида нового эл-та
        case 2:
            emit('createItem', props.treeItemData.kod_r, event.itemData.kod);
            break;
        case 3:
            emit('createItem', props.treeItemData.kod, event.itemData.kod);
            break;
        case 4:
            emit('expandItem', props.treeItemData.kod);
            break;
        case 5:
            onDeletePopupShow(props.treeItemData.kod, props.treeItemData.name).then(res => {
                if (res) emit('deleteItem', props.treeItemData.kod, props.treeItemData.kod_r);
            });
            break;
        default:
            dxUiNotify('Этот пункт меню пока не работает. Функция в разработке', 'info', 3000);
    }
};

// endregion
</script>

<style scoped>
.tep-tree-item-img {
    width: 20px;
    height: auto;
    margin-right: 10px;
}
</style>
